export default __webpack_public_path__ + "static/media/pic1.96760a48.jpg";